<template>
  <el-card style="width: 49%;min-height: 400px">
    <div ref="statistics" style="width: 100%;height: 600px"></div>
  </el-card>
</template>

<script>
import { defineComponent } from 'vue'
import chinaJson from '@/assets/json/chinaGeo.json';

export default defineComponent({
  props: {
    idProvinceData: Array
  },
  data() {
    return {
      myCharts: null
    }
  },
  watch: {
    idProvinceData: {
      handler(val) {
        this.setChart();
      },
      deep: true
    }
  },
  methods: {
    setChart() {
      if (!this.myCharts) {
        this.myCharts = this.$echarts.init(this.$refs.statistics);
      }
      let idProvinceData = this.idProvinceData;
      if (!idProvinceData) {
        return;
      }

      this.$echarts.registerMap('China', chinaJson);

      let seriesData = [];
      let maxSalary = 50000;
      for (let i in this.idProvinceData) {
        let idProvince = this.idProvinceData[i];
        seriesData.push({name: idProvince.name, value: idProvince.actualSalary })
        if (idProvince.actualSalary > maxSalary) {
          maxSalary = idProvince.actualSalary;
        }
      }

      let option = {
        tooltip: {
          trigger: 'item',
          showDelay: 0,
          transitionDuration: 0.2
        },
        visualMap: {
          left: 'right',
          min: 0,
          max: maxSalary,
          inRange: {
            color: [
              '#313695',
              '#4575b4',
              '#74add1',
              '#abd9e9',
              '#e0f3f8',
              '#ffffbf',
              '#fee090',
              '#fdae61',
              '#f46d43',
              '#d73027',
              '#a50026'
            ]
          },
          text: ['High', 'Low'],
          calculable: true
        },
        series: [
          {
            name: '发送总额',
            type: 'map',
            roam: true,
            map: 'China',
            emphasis: {
              label: {
                show: true
              }
            },
            data: seriesData
          }
        ]
      };

      this.myCharts.setOption(option);

    }
  }
})
</script>
